import MeetingDeleteConfirmation from './MeetingDeleteConfirmation';

export default MeetingDeleteConfirmation;
